import { Seo } from "@/components/Seo";
import { Hero } from "@/components/home/Hero";
import { TrustBar } from "@/components/home/TrustBar";
import { ServicesSection } from "@/components/home/ServicesSection";
import { WhyChooseUs } from "@/components/home/WhyChooseUs";
import { HowItWorks } from "@/components/home/HowItWorks";
import { BeforeAfter } from "@/components/home/BeforeAfter";
import { ServiceAreasSection } from "@/components/home/ServiceAreasSection";
import { ReviewsSection } from "@/components/home/ReviewsSection";
import { FaqSection } from "@/components/home/FaqSection";
import { CtaBand } from "@/components/CtaBand";
import { localBusinessSchema, websiteSchema, organizationSchema, faqSchema } from "@/lib/schema";
import { FAQS } from "@/data/content";

export default function Home() {
  return (
    <>
      <Seo
        title="House Cleaning Melbourne — Professional House Cleaners"
        description="Professional house cleaning in Melbourne — servicing West Melbourne, East Melbourne and North Melbourne. Regular, deep, end-of-lease & one-off cleaning. ABN registered, insured & police checked. Get a free quote today."
        path="/"
        schema={[localBusinessSchema(), websiteSchema(), organizationSchema(), faqSchema(FAQS)]}
      />
      <Hero />
      <TrustBar />
      <ServicesSection limit={8} />
      <WhyChooseUs />
      <HowItWorks />
      <BeforeAfter />
      <ServiceAreasSection />
      <ReviewsSection />
      <FaqSection limit={6} />
      <CtaBand />
    </>
  );
}
